var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('ContentOrLoading',[(_vm.posiciones)?_c('div',{staticClass:"table-responsive"},[(!_vm.loading)?_c('b-table',{attrs:{"hover":"","items":_vm.posiciones,"fields":_vm.fields}}):_vm._e()],1):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }